import { connect } from 'react-redux'
import { PuzzleMenuItems, PuzzleMenu } from '../components'

const mapStateToProps1 = (state) => {
  const { user } = state.authentication
  const { language } = state.user
  return ({
    user,
    language
  })
}

const mapDispatchToProps1 = (dispatch, ownProps) => {
  return ({
    handleClickSearch: () => {
    }
  })
}

const CompPuzzleMenuItems = connect(
  mapStateToProps1,
  mapDispatchToProps1,
)(PuzzleMenuItems)


const mapStateToProps2 = (state) => {
  const { user } = state.authentication
  const { width } = state.window
  return ({
    user,
    width,
  })
}

const mapDispatchToProps2 = (dispatch, ownProps) => {
  return ({
  })
}

const CompPuzzleMenu = connect(
  mapStateToProps2,
  mapDispatchToProps2,
)(PuzzleMenu)

export { CompPuzzleMenuItems as PuzzleMenuItems, CompPuzzleMenu as PuzzleMenu }



// WEBPACK FOOTER //
// ./src/Pages/Puzzle/containers/PuzzleMenu.js